import { TextField } from "@mui/material";
import { cleanInputValue } from "../../helpers";
const TextInput = ({ inputValue, setInputValue, handleKeyDown }) => {
  return (
    <TextField
      id="inputBox"
      variant="outlined"
      placeholder="Country"
      fullWidth
      autoFocus
      inputRef={(input) => input && input.focus()}
      spellCheck="false"
      autoCorrect="false"
      autoComplete="off"
      sx={{
        backgroundColor: "background.default",
        border: "2px solid transparent",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "2px solid transparent",
          },
          "&:hover fieldset": {
            border: "2px solid transparent",
          },
          "&.Mui-focused fieldset": {
            border: "2px solid transparent",
          },
        },
      }}
      inputProps={{ maxLength: 40 }}
      value={inputValue}
      onChange={(e) => setInputValue(cleanInputValue(e.target.value))}
      onKeyDown={(e) => {
        if (e.code === "Enter") {
          handleKeyDown();
        }
      }}
    />
  );
};

export default TextInput;
